module.exports = __webpack_public_path__ + "static/media/Woobat_gaussian2.36ea8c6e.png";